import React, { Component } from "react";
import moment from "moment";
import SimpleReactLightbox from "simple-react-lightbox";
import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { RightIssuesSuggestion } from "./leftRightSection/RightIssuesSuggestion";
import { LeftIssuesSuggestion } from "./leftRightSection/LeftIssuesSuggestion";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  get_only_one_issues_suggestions,
  comment_vendor_issues_suggestion,
} from "../../../store/actions/VendorIssuesSuggestionActions/VendorIssuesSuggestionActions";
import isEmpty from "../../../store/validation/is-Empty";

export class VendorOpenIssuesSuggestionEdit extends Component {
  constructor(props) {
    super();
    this.state = {
      allViewData: {},
      category: {},
      detailsProps: {},
      comment: [],
      contactDetails: "",
      enquiryEmails: "",
      displayChatScreen: false,
      onComment: "",
    };
  }

  componentDidMount() {
    const token = this.props.auth.user.accessToken;
    const issuesId = !isEmpty(this.props.location.state.issuesId)
      ? this.props.location.state.issuesId
      : "";
    if (!isEmpty(this.props.get_only_one_issues_suggestions)) {
      this.props.get_only_one_issues_suggestions(token, issuesId);
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.singleIssues) !== nextState.allViewData) {
      return {
        allViewData: !isEmpty(nextProps.singleIssues)
          ? nextProps.singleIssues
          : {},
        category: !isEmpty(nextProps.singleIssues.category)
          ? nextProps.singleIssues.category
          : "",
        detailsProps: !isEmpty(nextProps.singleIssues.restaurant_id)
          ? nextProps.singleIssues.restaurant_id
          : {},
        contactDetails: !isEmpty(nextProps.singleIssues.restaurant_id)
          ? nextProps.singleIssues.restaurant_id.contact_detail[0]
          : "",
        enquiryEmails: !isEmpty(nextProps.singleIssues.restaurant_id)
          ? nextProps.singleIssues.restaurant_id.enquiry_email[0]
          : "",
        comment: !isEmpty(nextProps.singleIssues.issue_comments)
          ? nextProps.singleIssues.issue_comments
          : [],
      };
    }
    return null;
  }

  onHandleComment = (e) => {
    this.setState({
      onComment: e.target.value,
    });
  };

  handleCommentSubmit = (e) => {
    const token = this.props.auth.user.accessToken;
    let issueId = this.state.allViewData._id;
    const formData = {
      respond: this.state.onComment,
    };
    this.props.comment_vendor_issues_suggestion(formData, token, issueId);
    this.setState({
      onComment: "",
    });
  };

  onChangeScreenChat = (e) => {
    this.setState({
      displayChatScreen: !this.state.displayChatScreen,
    });
  };

  renderResolutionLogBody = () => {
    const { allViewData } = this.state;
    if (!isEmpty(allViewData)) {
      return allViewData.resolution_logs.map((data, index) => (
        <React.Fragment key={index}>
          <tr>
            <td>
              <div>
                <h4>{moment(data.date).format("Do MMM YYYY")}</h4>
                <h4>{moment(data.date).format("hh:mm A")}</h4>
              </div>
            </td>
            <td>{data.comment}</td>
            <td>{data.initiator}</td>
          </tr>
        </React.Fragment>
      ));
    } else {
      return null;
    }
  };

  render() {
    const {
      allViewData,
      category,
      detailsProps,
      contactDetails,
      enquiryEmails,
      comment,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation
                displayText={`Issue No: ${allViewData.issue_id}`}
                displayBack={true}
                backButtonLink="/vendoropensuggestionissues"
              />
              <div className="super-admin-inside-right-side-panel pt-4 pb-4">
                <div className="row">
                  <div className="col-5">
                    <SimpleReactLightbox>
                      <LeftIssuesSuggestion
                        issuesData={allViewData}
                        restaurantData={detailsProps}
                        emailData={enquiryEmails}
                        contactDetails={contactDetails}
                        category={category}
                      />
                    </SimpleReactLightbox>
                  </div>
                  <div className="col-7">
                    <RightIssuesSuggestion
                      sendDataProps={allViewData}
                      displayInput={true}
                      displayChatScreenFunc={this.onChangeScreenChat}
                      displayChatScreen={this.state.displayChatScreen}
                      tableBody={this.renderResolutionLogBody()}
                      onChange={this.onHandleComment}
                      onComment="onComment"
                      commentValue={this.state.onComment}
                      onClickChatButton={this.handleCommentSubmit}
                      comment={comment}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorOpenIssuesSuggestionEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  singleIssues: state.vendorIssuesSuggestion.vendor_single_issue_suggestion,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_only_one_issues_suggestions,
  comment_vendor_issues_suggestion,
})(withRouter(VendorOpenIssuesSuggestionEdit));
